import React,{createContext,useContext,useId} from 'react';
import {useCareerLanguage} from './CareerLanguage';

export const CareerValidation=createContext({issues:{},attempt:0});
// Error text stays outside the label (and out of its accessible name), but is
// associated with each control. Existing hint descriptions are preserved.
export default function CareerField({name,children,as:Tag='label',className='',...props}){
 const {issues,attempt}=useContext(CareerValidation),{t}=useCareerLanguage(),id=useId(),issue=issues[name];
 const decorate=nodes=>React.Children.map(nodes,node=>{
  if(!React.isValidElement(node)||typeof node.type!=='string')return node;
  const control=['input','select','textarea'].includes(node.type)||node.props.role==='combobox';
  const attributes=control?{'aria-invalid':issue?true:undefined,'aria-describedby':[node.props['aria-describedby'],issue?id:null].filter(Boolean).join(' ')||undefined}:{};
  return React.cloneElement(node,{...attributes,...(node.props.children?{children:decorate(node.props.children)}:{})});
 });
 const content=typeof children==='function'?children({'aria-invalid':issue?true:undefined,'aria-describedby':issue?id:undefined}):decorate(children);
 return <div {...props} data-cw-field={name} data-cw-invalid={issue?'true':undefined} className={`cw-field ${className}${issue?' cw-field-invalid cw-field-nudge-'+(attempt%2):''}`}>
  <Tag>{content}</Tag>{issue&&<span id={id} className="cw-field-error">{t(issue)}</span>}
 </div>;
}

export function focusCareerIssue(root){
 const field=root?.querySelector('[data-cw-invalid="true"]');
 if(!field)return;
 const control=field.querySelector('input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled])');
 control?.focus({preventScroll:true});
 field.scrollIntoView?.({block:'center',behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
}
